import { ListTree } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { HoverHintTrigger } from "@/components/ui/title-help";

import { AssemblyHubBomHoverHint } from "./AssemblyHubBomHoverHint";
import type { HubBomLine, HubBomResponse } from "./assemblyApi";

export function AssemblyHubBomButton({
  lines,
  bomMeta,
  loading,
  errorMessage,
}: {
  lines: HubBomLine[];
  bomMeta?: Pick<HubBomResponse, "source" | "reference_sku" | "note"> | null;
  loading?: boolean;
  errorMessage?: string | null;
}): JSX.Element {
  return (
    <HoverHintTrigger
      trigger={
        <Button type="button" variant="secondary" size="sm" className="shrink-0" aria-label="Bill of materials">
          <ListTree className="h-4 w-4" aria-hidden />
          BOM
        </Button>
      }
    >
      <AssemblyHubBomHoverHint
        lines={lines}
        bomMeta={bomMeta}
        loading={loading}
        errorMessage={errorMessage}
      />
    </HoverHintTrigger>
  );
}
